import { render, staticRenderFns } from "./navigationFooter.vue?vue&type=template&id=d04b3f08&"
import script from "./navigationFooter.vue?vue&type=script&lang=js&"
export * from "./navigationFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports